module.exports = __webpack_public_path__ + "assets/profilepress.24378eb6.svg";